import { Button, ModalWindow } from '~/components';
import { t } from 'i18next';
import { ChipIcon, UtilityIcon, XIcon } from '~/icons';
import { apiCall } from '~/providers';
import { toast } from 'react-toastify';
import {
  BoxInfoDeviceDisassociate, ContainerDeviceModalDisassociate, ContainerDmtDisassociate, FooterModalDisassociate, HeaderModalDisassociate,
} from '../DMTs/styles';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useStateVar } from '~/helpers/useStateVar';
import { useEffect } from 'react';
import { ButtonWithoutStyle } from '../DMTs/DmtRealTime/styles';
import { DeviceStatusBadge } from './DeviceStatusBadge';

export function DeviceDisassociate({
  devId, render, devInfo,
}) {
  const isIntegration = devId?.startsWith('DMA') || devId?.startsWith('DRI');
  const match = useRouteMatch<{ devId: string, integrId: string }>();
  const history = useHistory();
  const [state, _render, setState] = useStateVar({
    linkBase: isIntegration ? match.url.split('/integracoes')[0] : match.url.split(`/${match.params.devId}`)[0],
    isLoading: false,
    modal: false,
  });

  useEffect(() => {
    function handleKeyDown(event) {
      if (event.key === 'Escape') {
        setState({ modal: false });
      }
    }
    if (state.modal) {
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [state.modal]);

  async function desassociateDevice() {
    setState({ isLoading: true });
    try {
      await apiCall('/devices/disassociate', { DEVICE_CODE: devId, UNIT_ID: devInfo.UNIT_ID, CLIENT_ID: devInfo.CLIENT_ID });
      toast.success(t('sucesso'));
      if (isIntegration && match.path.endsWith('perfil')) {
        history.push(`/integracoes/info/diel/${devId}/editar`);
      }
      else if (isIntegration && match.path.endsWith('editar')) {
        history.push(`/integracoes/info/diel/${devId}/perfil`);
      }
      else if (match.path.endsWith('editar')) history.push(`${state.linkBase}/${devId}/informacoes`);
      else if (match.path.endsWith('informacoes')) history.push(`${state.linkBase}/${devId}/editar`);
      render();
    } catch (err) {
      toast.error(t('houveErroDesassociando'));
      console.log(err);
    }
    setState({ isLoading: false });
  }
  const hasUtility = devInfo && (!!devInfo.dmt?.utilitiesList?.length || !!devInfo.dal?.illuminationList?.length);
  return (
    <>
      <ContainerDmtDisassociate>
        <div style={{ flexWrap: 'wrap' }}>
          <div style={{ margin: '3px' }}>
            { hasUtility ? <UtilityIcon /> : <ChipIcon /> }
          </div>
          {devId}
          <DeviceStatusBadge deviceStatus={devInfo?.DEVICE_STATUS} />
        </div>
        {
          devInfo?.CLIENT_ID && (
            <Button variant="blue-white" style={{ width: 177, textTransform: 'capitalize' }} onClick={() => setState({ modal: true })} disabled={state.isLoading}>
              {t('desassociarDispositivo')}
            </Button>
          )
        }
      </ContainerDmtDisassociate>
      {
        state.modal && (
          <ModalWindow style={{ maxWidth: '450px' }}>
            <HeaderModalDisassociate>
              <div>
                { hasUtility ? <UtilityIcon /> : <ChipIcon /> }
                {t('desassociarDispositivo')}
              </div>
              <ButtonWithoutStyle onClick={() => setState({ modal: false })}>
                <XIcon />
              </ButtonWithoutStyle>
            </HeaderModalDisassociate>
            <ContainerDeviceModalDisassociate>
              <span>{t('textoDesassociarDispositivoModal')}</span>
              <BoxInfoDeviceDisassociate>
                <p>{`${t('dispositivo')}: ${devId}`}</p>
                <p>{`${t('cliente')}: ${devInfo.CLIENT_NAME}`}</p>
                <p>{`${t('unidade')}: ${devInfo.UNIT_NAME}`}</p>
                {
                  devInfo.GROUP_NAME && (<p>{`${t('maquina')}: ${devInfo.GROUP_NAME}`}</p>)
                }
                {
                  hasUtility && (<p>{`${t('utilitarios')}: ${devInfo.dmt?.utilitiesList?.length || devInfo.dal?.illuminationList?.length}`}</p>)
                }
              </BoxInfoDeviceDisassociate>
            </ContainerDeviceModalDisassociate>
            <FooterModalDisassociate>
              <ButtonWithoutStyle onClick={() => setState({ modal: false })}>
                <p>{t('cancelar')}</p>
              </ButtonWithoutStyle>
              <Button
                style={{
                  fontSize: 11, borderRadius: 4, textTransform: 'unset', cursor: 'pointer',
                }}
                variant="primary"
                onClick={() => desassociateDevice()}
              >
                {t('confirmarDesassociar')}
              </Button>
            </FooterModalDisassociate>
          </ModalWindow>
        )
      }
    </>
  );
}
